/* eslint-disable react/no-unescaped-entities */
import { Title, DocumentList, DocumentSegment } from "@clubofcode/ui";
import { LegalLayout } from "~/components/Layout";
import { LegalLinkTarget } from "~/components/Layout/LegalLayout";
import { Link } from "~/components/Link";

const TermsAndConditions = () => {
  return (
    <LegalLayout>
      <section className="text-justify space-y-10">
        <div className="text-center mb-12">
          <Title as="h1" className="text-xl font-bold">
            Allgemeine Geschäftsbedingungen
          </Title>
          <p>
            der
            <br />
            <strong>Club of Code Technology GmbH & Co. KG</strong>
            <br />
            Heringer Fahrweg 3<br />
            65597 Hünfelden
            <br />
            Deutschland
          </p>
        </div>

        <Title as="h2" className="text-lg font-bold underline">
          Allgemeine Regelungen
        </Title>

        <DocumentSegment title="1. Allgemeines und Geltungsbereich">
          <DocumentList>
            <li>
              Diese allgemeinen Geschäftsbedingungen („AGB“) gelten in Bezug auf
              die Leistungen der Club of Code Technology UG & Co. KG, Heringer
              Fahrweg 3, 65597 Hünfelden, Deutschland (nachstehend auch „wir“
              oder „Club of Code“ genannt), die gegenüber dem Nutzer
              (nachstehend „Nutzer“ oder „Sie“ genannt) im Rahmen der Nutzung
              unserer Club of Code Plattform (nachfolgend auch „Plattform“)
              erbracht werden.
            </li>
            <li>
              Diese AGB gelten unabhängig davon, ob Sie als Verbraucher,
              Unternehmer oder Kaufmann agieren. Gegenüber Verbrauchern gelten
              einige Besonderheiten, auf die wir ggf. in diesen AGB an den
              entsprechenden Stellen hinweisen. Verbraucher ist jede natürliche
              Person, die ein Rechtsgeschäft zu Zwecken abschließt, die
              überwiegend weder ihrer gewerblichen noch ihrer selbständigen
              beruflichen Tätigkeit zugerechnet werden können (§ 13 BGB).
              Unternehmer ist eine natürliche oder juristische Person oder eine
              rechtsfähige Personengesellschaft, die bei Abschluss eines
              Rechtsgeschäfts in Ausübung ihrer gewerblichen oder selbständigen
              beruflichen Tätigkeit handelt (§ 14 BGB).
            </li>
            <li>
              Ihre Allgemeinen Geschäftsbedingungen finden keine Anwendung,
              gleich ob Sie ausdrücklich hierauf verweisen oder wir nicht
              ausdrücklich widersprechen. Ihre Allgemeinen Geschäftsbedingungen
              werden nur Bestandteil dieses Vertrags, wenn wir ihnen
              ausdrücklich zustimmen. Individuelle Vereinbarungen zwischen uns
              in Angeboten, Auftragsbestätigungen, Annahmeerklärungen etc. gehen
              den Regelungen dieser AGB vor.
            </li>
          </DocumentList>
        </DocumentSegment>

        <DocumentSegment title="2. Vertragsgegenstand">
          <DocumentList>
            <li>
              Wir stellen mit Club of Code eine Plattform für die Bewerbung von
              Entwicklern bei potentiellen Arbeit- bzw. Auftraggebern bereit.
              Auf unserer Plattform können Nutzer ein Profil anlegen, ihren
              bisherigen Bildungsweg und Lebenslauf beschreiben, sich aktiv auf
              offene Stellen bewerben und über den Chat interaktiv mit
              potentiellen Arbeit- und Auftraggebern kommunizieren.
            </li>
            <li>
              Gegenstand dieser AGB ist die unentgeltliche Bereitstellung der
              Plattform sowie Ihre Möglichkeit, die Plattform über ein
              unentgeltliches Profil zu nutzen.
            </li>
            <li>
              Wir treten weder als Makler noch als sonstiger Vermittler auf. Wir
              sind insbesondere kein Personalvermittlungsdienst. Wir stellen
              lediglich die technische Grundlage für die Kommunikation und
              Anbahnung von Verträgen und Vereinbarungen zwischen Ihnen als
              Nutzer und potentiellen Arbeit- bzw. Auftraggebern bereit. Für
              Verträge, die zwischen Nutzer und Arbeit- bzw. Auftraggeber
              geschlossen werden, sind diese allein verantwortlich. Wir werden
              nicht Vertragspartner dieser Verträge. Den potentiellen Arbeit-
              bzw. Auftraggebern stellen wir Club of Code als
              Software-as-a-Service (SaaS) bereit, mit der sie die
              entsprechenden Prozesse zur Anbahnung eines Anstellungs- bzw.
              Auftragsverhältnisses abbilden können. Hierfür erhalten wir eine
              sich an der Laufzeit und am Umfang der gebuchten Leistungen
              orientierende Gebühr. Wir erhalten keine Provision für
              erfolgreiche Vermittlungsvorgänge und auch sonst keine
              erfolgsorientierte Vergütung.
            </li>
            <li>
              Unsere Leistungen umfassen insbesondere:
              <DocumentList>
                <li>
                  Anlegen eines Profils inklusive des Bildungsweges und des
                  beruflichen Lebenslaufs;
                </li>
                <li>Bewerben auf einen Job;</li>
                <li>Erhalten von Jobangeboten von Unternehmen;</li>
                <li>
                  Anlegen von Jobsuchprofilen um in regelmäßigen Abständen
                  automatisierte Stellenvorschläge zu erhalten;
                </li>
                <li>Chat zum Austausch mit den Unternehmen.</li>
              </DocumentList>
            </li>
            <li>
              Eine Übersicht über das gesamte Leistungsportfolio unserer
              Plattform ergibt sich aus der Leistungsbeschreibung, die in ihrer
              jeweiligen Fassung auf unserer Website (
              <Link
                className="text-indigo-500 hover:underline"
                to={LegalLinkTarget.Business.SPECIFICATION_OF_SERVICES}
              >
                zur Leistungsbeschreibung
              </Link>
              ) abrufbar ist.
            </li>
          </DocumentList>
        </DocumentSegment>

        <DocumentSegment title="3. Nutzung unserer Leistungen & Registrierung">
          <DocumentList>
            <li>
              Zur Nutzung unserer Leistungen ist Ihre kostenlose Registrierung
              als Nutzer erforderlich. Als Nutzer können sich ausschließlich
              unbeschränkt geschäftsfähige natürliche Personen registrieren.
            </li>
            <li>
              Zur Registrierung ist das auf unserer Plattform bereitgestellte
              Registrierungsformular vollständig und wahrheitsgemäß unter Angabe
              eines Nutzernamens auszufüllen und an uns abzusenden. Ihr
              Nutzername darf nicht gegen Rechte Dritter oder gegen die guten
              Sitten verstoßen. Wir sind berechtigt, schriftliche Nachweise zur
              Überprüfung der angegebenen Daten anzufordern.
            </li>
            <li>
              Mit der Absendung des Registrierungsformulars geben Sie ein
              verbindliches Angebot an uns zum Abschluss eines Nutzungsvertrages
              über eine unentgeltliche Basisversion ab. Der Nutzungsvertrag wird
              durch die Bestätigung der Registrierung und die Freischaltung
              Ihres Nutzerkontos durch uns geschlossen. Jeder Nutzer darf sich
              nur einmal registrieren.
            </li>
            <li>
              Zur Nutzung unserer Leistungen sind mindestens folgende technische
              Voraussetzungen erforderlich:
              <DocumentList>
                <li>Internet-Verbindung</li>
                <li>Aktueller Internetbrowser</li>
              </DocumentList>
            </li>
            <li>
              Wir haben das Recht, Sie von der Nutzung unserer Leistungen zu
              sperren oder auszuschließen und Ihr Nutzerkonto sowie sämtliche
              von Ihnen gebuchten Leistungen zu löschen, wenn uns begründete
              Anhaltspunkte dafür vorliegen, dass Sie gegen wesentliche
              Pflichten dieser Geschäftsbedingungen bzw. gegen Gesetz und Recht
              verstoßen (haben). Wir werden Sie in einem solchen Fall über den
              geplanten Ausschluss per E-Mail informieren und Ihnen die
              Möglichkeit zur Stellungnahme innerhalb von mindestens 30 Tagen
              geben. In jedem Fall werden wir Ihre berechtigten Interessen
              berücksichtigen bei der Entscheidung über die Sperrung oder den
              Ausschluss und Ihre Stellungnahme entsprechend bewerten. Das
              Ergebnis teilen wir Ihnen vor der Sperrung bzw. vor dem Ausschluss
              mit. Das Recht zur außerordentlichen Kündigung bleibt unberührt.
            </li>
          </DocumentList>
        </DocumentSegment>
        <DocumentSegment title="4. Ihr Nutzungsrecht an unseren Leistungen">
          <DocumentList>
            <li>
              Sie erhalten ein einfaches, nicht ausschließliches, zeitlich auf
              die Dauer des Vertrages befristetes und räumlich unbeschränktes
              Recht zur Nutzung unserer Leistungen.
            </li>
            <li>
              Zur Ausstellung, öffentlichen Wiedergabe, insbesondere der
              öffentlichen Zugänglichmachung, Bearbeitung, Umgestaltung,
              Übersetzung, Dekompilierung oder sonstigen Umgestaltung unserer
              Leistungen sind Sie nicht berechtigt. Ihre Rechte aus §§ 69d Abs.
              3, 69e UrhG bleiben unberührt.
            </li>
            <li>
              Die Inhalte unserer Leistungen stehen in unserem ausschließlichen
              Eigentum bzw. in unserer ausschließlichen Rechteinhaberschaft bzw.
              im Eigentum / in der Rechteinhaberschaft unserer Dienstleister.
              Alle Inhalte sind durch nationales und internationales Recht,
              insbesondere Urheberrecht, geschützt. Die unerlaubte Verbreitung,
              Vervielfältigung, Verwertung oder anderweitige Verletzung unserer
              gewerblichen Schutzrechte und Urheberrechte werden zivil- und/oder
              strafrechtlich verfolgt.
            </li>
          </DocumentList>
        </DocumentSegment>
        <DocumentSegment title="5. Verfügbarkeit">
          <p>
            Aus technischen Gründen können wir eine dauerhafte und vollständige
            Verfügbarkeit der Server, auf denen unsere Leistungen betrieben
            werden, nicht gewährleisten. Zeitweise kann die Verfügbarkeit
            unserer Website bzw. einzelner Services – insbesondere wegen der
            notwendigen Durchführung von Wartungs- oder Reparaturarbeiten –
            daher eingeschränkt sein.
          </p>
        </DocumentSegment>
        <DocumentSegment title="6. Haftungsbeschränkungen">
          <DocumentList>
            <li>
              Unsere Haftung aus dem zwischen uns geschlossenen Vertrag, gleich
              aus welchem Rechtsgrund, für Ihre Schäden, die nicht aus der
              Verletzung des Lebens, des Körpers oder der Gesundheit stammen,
              ist der Höhe nach beschränkt auf die im Zeitpunkt des
              Vertragsschlusses typischerweise vorhersehbaren Schäden und dem
              Grunde nach auf wesentliche Vertragspflichten, soweit der Schaden
              durch uns oder durch einen gesetzlichen Vertreter oder einen
              Erfüllungsgehilfen weder vorsätzlich noch grob fahrlässig
              herbeigeführt wurde.
            </li>
            <li>
              Diese Haftungsbeschränkung gilt nicht, soweit der Schaden auf
              einer vorsätzlichen oder grob fahrlässigen Verletzung wesentlicher
              Vertragspflichten durch uns oder durch einen gesetzlichen
              Vertreter oder einen Erfüllungsgehilfen beruht. Vertragswesentlich
              ist eine Pflicht, deren Erfüllung die ordnungsgemäße Durchführung
              des Vertrages erst ermöglicht und auf deren Einhaltung Sie
              regelmäßig vertrauen dürfen.
            </li>
            <li>
              Für sämtliche durch Ihre Nutzung unserer Plattform zustande
              gekommenen Verträge und Vereinbarungen sind Sie selbstständig
              verantwortlich. Wir agieren diesbezüglich weder als Vermittler
              noch als von Ihnen Beauftragter. Sollten wir von Dritten aufgrund
              von durch Sie auf oder über unsere/e Plattform vorgenommenen
              Handlungen, geschlossenen Verträgen und Vereinbarungen oder aus
              diesen resultierenden Rechtsverletzungen in Anspruch genommen
              werden, sind Sie verpflichtet, uns von sämtlichen damit im
              Zusammenhang stehenden Ansprüchen freizustellen. Dazu haben Sie
              uns die Kosten einer angemessenen Rechtsverteidigung und sonstige
              durch die Inanspruchnahme entstehende Kosten zu ersetzen.
            </li>
          </DocumentList>
        </DocumentSegment>
        <DocumentSegment title="7. Grundsätze zur Erbringung unserer Leistungen">
          <DocumentList>
            <li>
              Wir stellen Ihnen mit unserer Plattform und ihren Funktionen
              lediglich eine technische Grundlage für die hiermit durch Sie in
              den Grenzen der erworbenen Leistungen (siehe insbesondere die
              Leistungsbeschreibung unter{" "}
              <Link
                className="text-indigo-500 hover:underline"
                to={LegalLinkTarget.Users.SPECIFICATION_OF_SERVICES}
              >
                {"https://clubofcode.io" +
                  LegalLinkTarget.Users.SPECIFICATION_OF_SERVICES}
              </Link>
              ) abzubildenden Zwecke zur Verfügung. Wir übernehmen keine
              Verantwortung für die mit unserer Plattform ausgeführten
              Handlungen bzw. für die mit unserer Plattform verarbeiteten
              Inhalte. Für sämtliche von Ihnen mit unserer Plattform
              ausgeführten Handlungen und verarbeiteten Inhalte gelten
              ausschließlich die Vereinbarungen und Verträge, die Sie mit Ihren
              Kunden, Partnern, Mitarbeitern etc., mit denen Sie bzw. für die
              Sie unsere Plattform einsetzen, bzw. das Gesetz.
            </li>
            <li>
              Für die Inanspruchnahme unserer Leistungen gelten grds. die
              mietrechtlichen Vorschriften. Instandhaltungsmaßnahmen wie
              Störungsbeseitigungen, Updates oder Weiterentwicklungen sind
              Bestandteil unserer Leistung. Ein weitergehender Support wird bei
              entsprechender Vereinbarung angeboten. Über die
              Instandhaltungsmaßnahmen hinaus findet das gesetzliche
              Mietmängel-Gewährleistungsrecht Anwendung.
            </li>
            <li>
              Anpassungen, Änderungen und Ergänzungen unserer Leistungen sowie
              Maßnahmen, die der Feststellung und Behebung von
              Funktionsstörungen dienen, werden nur dann zu einer
              vorübergehenden Unterbrechung oder Beeinträchtigung der
              Erreichbarkeit führen, wenn dies aus technischen Gründen zwingend
              notwendig ist.
            </li>
            <li>
              Sie dürfen unsere Leistungen nicht an Dritte zur gewerblichen
              Nutzung überlassen.
            </li>
            <li>
              Über Links oder Funktionalitäten in unseren Leistungen können Sie
              zu fremden Websites und Software gelangen, die nicht von uns
              betrieben werden und für die wir nicht verantwortlich sind. Solche
              Links oder Funktionalitäten sind entweder eindeutig gekennzeichnet
              oder durch einen Wechsel in der Adresszeile des Browsers oder eine
              Änderung der Benutzeroberfläche erkennbar.
            </li>
            <li>
              Wir behalten uns vor, unsere Leistungen sowie die hierauf
              bezogenen Dokumente und Anlagen unter Berücksichtigung Ihrer
              Interessen zu ändern, anzupassen und im Funktionsumfang zu erhöhen
              oder reduzieren, sofern wir hierdurch nicht unsere vertraglich
              übernommenen Hauptleistungspflichten Ihnen gegenüber verletzen.
              Über wesentliche und die Vertragsbeziehung mit Ihnen ändernde
              Modifikationen & Einstellungen werden wir Sie rechtzeitig vorab
              informieren. Sie haben das Recht, Änderungen zu widersprechen.
              Widersprechen Sie, werden wir gemeinsam versuchen, Alternativen zu
              finden. Werden diese nicht gefunden, haben beide Parteien das
              Recht, diesen Vertrag außerordentlich zu kündigen.
            </li>
            <li>
              Wir sichern unsere Systeme gegen Virenbefall. Dennoch kann ein
              Virenbefall nie vollständig ausgeschlossen werden. Zudem kann es
              vorkommen, dass unberechtigte Dritte Nachrichten unter Verwendung
              unseres Namens ohne unser Einverständnis versenden, die
              beispielsweise Viren oder sog. Spyware enthalten oder zu
              Web-Inhalten linken, die Viren oder Spyware enthalten. Darauf
              haben wir keinen Einfluss. Sie sollten daher alle eingehenden
              Nachrichten, die unter unserem Namen versandt werden, prüfen. Dies
              gilt auch für eventuelle Nachrichten von anderen Nutzern.
            </li>
            <li>
              Wir sind nicht verantwortlich für Schäden oder Datenverluste, die
              durch die Installation von Software, die nicht von uns herrührt,
              auf Ihren Endgeräten entstehen können.
            </li>
            <li>
              Sie verpflichten sich, unter keinen Umständen Ihren Anmeldenamen
              oder Kennwort bekannt zu geben oder den Anmeldenahmen oder das
              Kennwort eines anderen Nutzers unbefugt zu verwenden. Benutzt ein
              Dritter Ihr Konto, nachdem er an die Zugangsdaten gelangt ist,
              weil Sie diese nicht hinreichend vor fremdem Zugriff gesichert
              haben, müssen Sie sich so behandeln lassen, als ob Sie gehandelt
              hätten.
            </li>
            <li>
              Im Falle eines begründeten Verdachts, dass Zugangsdaten unbefugten
              Dritten bekannt wurden, sind wir aus Sicherheitsgründen
              berechtigt, aber nicht verpflichtet, nach freiem Ermessen die
              Zugangsdaten ohne vorherige Ankündigung selbstständig zu ändern
              bzw. die Nutzung des Kontos zu sperren. Wir werden den
              berechtigten Nutzer hierüber unverzüglich informieren und ihm auf
              Anforderung innerhalb angemessener Frist die neuen Zugangsdaten
              mitteilen. Sie haben keinen Anspruch darauf, dass die
              ursprünglichen Zugangsdaten wiederhergestellt werden.
            </li>
            <li>
              Sie haben uns unverzüglich zu informieren, sobald Sie davon
              Kenntnis erlangen, dass unbefugte Dritte Ihre Zugangsdaten zur
              Plattform nutzen. Wir weisen darauf hin, dass Zugangsdaten aus
              Sicherheitsgründen regelmäßig geändert werden sollten.
            </li>
            <li>
              Sie haben uns unverzüglich zu informieren, sobald Sie davon
              Kenntnis erlangen, dass unbefugte Dritte Ihre Zugangsdaten zur
              Plattform nutzen. Wir weisen darauf hin, dass Zugangsdaten aus
              Sicherheitsgründen regelmäßig geändert werden sollten.
            </li>
            <li>
              Bei der Nutzung unserer Leistungen ist es Ihnen untersagt:
              <DocumentList>
                <li>
                  Schutzrechte Dritter wie Marken, Urheber- und Namensrechte zu
                  verletzen,
                </li>
                <li>andere Nutzer und Dritte zu belästigen,</li>
                <li>
                  Maßnahmen, Mechanismen oder Software in Verbindung mit der
                  Plattform zu verwenden, die die Funktion und den Betrieb der
                  Plattform stören können,
                </li>
                <li>
                  Maßnahmen zu ergreifen, die eine unzumutbare oder übermäßige
                  Belastung der technischen Kapazitäten der Plattform zur Folge
                  haben können,
                </li>
                <li>
                  Inhalte zu blockieren, zu überschreiben oder zu modifizieren,
                </li>
                <li>
                  der Plattform Elemente hinzuzufügen oder Elemente der
                  Plattform zu ändern, zu löschen oder in einer anderen Form zu
                  modifizieren,
                </li>
                <li>
                  grafische Elemente zu kopieren, zu entnehmen oder anderweitig
                  zu verwenden oder zu versuchen, den Quellcode der Plattform zu
                  dekompilieren (vorbehaltlich § 69e UrhG),
                </li>
                <li>
                  Hilfsmittel anzuwenden, die in den Betrieb der Plattform
                  eingreifen (insbesondere sog. „Bots“, „Hacks“ etc.),
                </li>
                <li>
                  sich Premium-Funktionen oder sonstige Vorteile, wie etwa die
                  systematische oder automatische Steuerung der Plattform oder
                  einzelner Funktionen der Plattform, durch die Verwendung von
                  Software Dritter oder sonstigen Anwendungen zu verschaffen
                  oder Programmfehler zum eigenen Vorteil auszunutzen
                  („Exploits“),
                </li>
                <li>
                  kommerzielle Werbung für Produkte bzw. Programme Dritter in
                  Zusammenhang mit unseren Leistungen zu verbreiten,
                </li>
                <li>
                  schadcodehafte oder virenbehaftete Dokumente, Dateien,
                  IT-Systeme Dritter und Daten im Zusammenhang mit unseren
                  Leistungen zu verwenden,
                </li>
                <li>
                  über bereitgestellte Funktionalitäten und Schnittstellen
                  hinausgehende Mechanismen, Software und Skripte einzusetzen,
                  insbesondere wenn hierdurch unsere Leistungen blockiert,
                  modifiziert, kopiert oder überschrieben werden, sowie
                </li>
                <li>
                  unsere Services durch Datenveränderung (§ 303a StGB),
                  Computersabotage (§ 303b StGB), Fälschung beweiserheblicher
                  Daten (§ 269, 270 StGB), Unterdrückung beweiserheblicher Daten
                  (§ 274 StGB), Computerbetrug (§ 263a StGB), Ausspähen von
                  Daten (§ 202a StGB), Abfangen von Daten (§ 202b StGB) oder
                  andere Straftaten zu beeinträchtigen.
                </li>
              </DocumentList>
            </li>
          </DocumentList>
        </DocumentSegment>
        <DocumentSegment title="8. Vertragsdauer & Rücktritt/Kündigung">
          <DocumentList>
            <li>
              Die Dauer des zwischen uns bestehenden Vertrags orientiert sich an
              der Dauer der von Ihnen gebuchten Leistung. Der unentgeltliche
              Vertrag in der Basisversion läuft grds. auf unbestimmte Zeit.
            </li>
            <li>
              Die zwischen uns bestehenden Verträge können mit einer Frist von 4
              Wochen gekündigt werden. Eine Kündigung erfolgt durch E-Mail an
              contact@clubofcode.io. Sollte nicht gekündigt werden, verlängert
              sich der Vertrag über die Premium Version jeweils um 1 Monat.
            </li>
            <li>
              Das Recht zur außerordentlichen Kündigung aus wichtigem Grund (§
              314 BGB) bleibt unberührt. Ein wichtiger Grund liegt für uns
              insbesondere vor, wenn (i) Sie schwerwiegend gegen diese AGB
              verstoßen, oder (ii) Sie mit der Bezahlung der Kosten für die
              Inanspruchnahme kostenpflichtiger Leistungen trotz einer Mahnung
              und einer Nachfrist für die Zahlung von mindestens zwei
              Kalenderwochen in Verzug sind.
            </li>
          </DocumentList>
        </DocumentSegment>
        <DocumentSegment title="9. Gerichtsstand">
          <p>
            Sofern Sie als Unternehmen agieren oder Kaufmann im Sinne des HGB
            sind, ist unser Sitz Gerichtsstand für alle Streitigkeiten aus
            diesem Vertrag. Bei Verträgen mit Verbrauchern gelten die
            gesetzlichen Regelungen über das jeweils zuständige Gericht.
          </p>
        </DocumentSegment>
        <DocumentSegment title="10. Online-Streitbeilegung">
          <p>
            Informationen zur Online-Streitbeilegung für Verbraucher: Wir weisen
            auf die Möglichkeit der Online-Beilegung von Streitigkeiten (sog.
            „OS-Plattform“) hin. Die OS-Plattform können Verbraucher als
            Anlaufstelle zur außergerichtlichen Beilegung von Streitigkeiten
            betreffend vertragliche Verpflichtungen, die aus Online-Kauf- oder
            Leistungsverträgen erwachsen, nutzen. Die OS-Plattform ist unter
            folgendem Link erreichbar: http://ec.europa.eu/consumers/odr. Wir
            sind nicht bereit, an der Beilegung von Streitigkeiten über diese
            OS-Plattform, teilzunehmen.
          </p>
        </DocumentSegment>
        <DocumentSegment title="11. Sonstiges">
          <DocumentList>
            <li>
              Sollte eine Bestimmung dieser AGB ungültig oder undurchsetzbar
              sein oder werden, so bleiben die übrigen Bestimmungen dieser AGB
              hiervon unberührt, es sei denn, dass durch den Wegfall einzelner
              Klauseln eine Vertragspartei so unzumutbar benachteiligt würde,
              dass ihr ein Festhalten am Vertrag nicht mehr zugemutet werden
              kann.
            </li>
            <li>
              Änderungen und Ergänzungen der AGB sowie des gesamten zwischen uns
              bestehenden Vertrags bedürfen zu ihrer Wirksamkeit der Textform.
              Änderungen und Ergänzungen des Vertrags, die aufgrund geänderter
              rechtlicher oder technischer Anforderungen an unsere
              Leistungserbringung von uns vorgenommen werden (müssen) und die
              keine negativen Auswirkungen auf die Ihnen zustehenden Leistungen
              haben, werden wirksam, wenn Sie einer Änderung nicht innerhalb
              eines Monats nach Zugang einer Änderungsmitteilung in Textform
              widersprechen und wir Sie vorab auf Ihr Widerspruchsrecht
              hingewiesen haben. Widersprechen Sie der Änderung, gilt der
              Vertrag unverändert weiter und wir sind zur außerordentlichen
              Kündigung des Vertrags mit einer Frist von einem Monat zum Ende
              des nächsten Kalendermonats berechtigt. Änderungen und Ergänzungen
              des Vertrags, die wir aufgrund geänderter Leistungs-, Vergütungs-
              oder sonstiger kaufmännischer oder operativer Anforderungen
              vornehmen möchten, werden nur wirksam, wenn Sie ihnen ausdrücklich
              zustimmen. Diese Zustimmung kann über das Klicken eines
              Einwilligungs-Buttons in der Änderungsmitteilung (E-Mail oder
              Pop-Up im Rahmen der Nutzung unserer Leistungen) bzw. auf einem
              sonstigen von uns für Sie bereitgestellten einfachem &
              transparentem Wege erteilt werden. Die Textform gilt auch für eine
              Änderung dieser Formklausel. Der Vorrang individueller
              Nebenabreden bleibt unberührt. Die vorgenannten Fristen gelten
              nicht und es besteht lediglich ein Informationsrecht über
              Änderungen des Vertrags, sofern die Änderungen zur Abwehr einer
              unvorhergesehenen und unmittelbar drohenden Gefahr notwendig sind,
              um Sie vor Betrug, Schadsoftware, Spam, Verletzungen des
              Datenschutzes oder anderen Cybersicherheitsrisiken zu schützen.
            </li>
            <li>
              Beide Parteien sind berechtigt, den Vertrag auf ein mit ihnen
              verbundenes Unternehmen, einen Rechtsnachfolger oder ein die
              jeweiligen Leistungen übernehmendes Unternehmen zu übertragen.
              Hierüber werden sie sich jeweils in Textform vor der geplanten
              Übertragung informieren.
            </li>
          </DocumentList>
        </DocumentSegment>
        <DocumentSegment title="12. Vergütung & Zahlungsbedingungen">
          <DocumentList>
            <li>
              Die Art und die Höhe der Vergütung für die von Ihnen gebuchte
              Leistung wird Ihnen im Buchungsprozess, in der Buchungsübersicht
              sowie in der Buchungsbestätigung mitgeteilt und versteht sich,
              sofern nicht ausdrücklich anders ausgewiesen, inkl. der
              gesetzlichen Umsatzsteuer.
            </li>
            <li>
              Sie werden im Rahmen des Buchungsvorgangs über die zur Verfügung
              stehenden Zahlungsarten informiert und können aus diesen die für
              Sie passende Zahlungsart auswählen.
            </li>
            <li>
              Sollten wir zur Abwicklung des Zahlungsvorgangs Drittanbieter
              einbinden, gelten hierfür zusätzlich deren Geschäftsbedingungen.{" "}
            </li>
            <li>
              Mit Versäumung einer gesetzlichen oder vereinbarten Zahlungsfrist
              geraten Sie unmittelbar in Verzug und wir sind berechtigt,
              entsprechende Verzugszinsen zu fordern.
            </li>
            <li>
              Soweit die Zahlung innerhalb der Europäischen Union (EU) erfolgt,
              erheben wir für keines der von uns verwendeten Zahlungsmittel eine
              gesonderte Gebühr. Bitte beachten Sie, dass wir Zahlungen
              lediglich von Konten innerhalb der EU akzeptieren. Etwaige Kosten
              jeglicher sonstigen Transaktion gehen zu Ihren Lasten.
            </li>
          </DocumentList>
        </DocumentSegment>
        <DocumentSegment title="13. Widerruf">
          <DocumentList>
            <li>
              Soweit Sie unsere Leistungen als Verbraucher in Anspruch nehmen,
              können Sie den zwischen uns über unsere Leistungen zustande
              gekommenen Vertrag wie folgt widerrufen:
            </li>
            <li>
              Widerrufsbelehrung
              <br />
              Sie können Ihre Vertragserklärung innerhalb von 14 Tagen ohne
              Angabe von Gründen in Textform (z.B. Brief, E-Mail) widerrufen.
              Die Frist beginnt nach Erhalt dieser Belehrung in Textform, jedoch
              nicht vor Vertragsschluss und auch nicht vor Erfüllung unserer
              Informationspflichten gemäß Artikel 246 § 2 in Verbindung mit § 1
              Abs. 1 und 2 EGBGB sowie unserer Pflichten gemäß § 312 e Abs. 1
              Satz 1 BGB in Verbindung mit Artikel 246 § 3 EGBGB. Zur Wahrung
              der Widerrufsfrist genügt die rechtzeitige Absendung des
              Widerrufs. Der Widerruf ist zu richten an:
              <br />
              Club of Code Technology GmbH & Co. KG <br />
              Heringer Fahrweg 3 <br />
              65597 Hünfelden <br />
              E-Mail: contact@clubofocode.io
            </li>
            <li>
              Widerrufsfolgen
              <br />
              Wenn Sie den Vertrag oder einzelne Buchungen wirksam widerrufen,
              werden wir Ihnen alle Zahlungen, die wir von Ihnen im Rahmen der
              widerrufenen Leistung/Buchung erhalten haben, unverzüglich und
              spätestens binnen vierzehn Tagen ab dem Tag zurückzahlen, an dem
              die Mitteilung über Ihren Widerruf dieses Vertrags bei uns
              eingegangen ist. In keinem Fall werden Ihnen wegen dieser
              Rückzahlung Entgelte berechnet.
              <br />
              <br />
              <b>Erlöschen des Widerrufsrechts bei digitalen Leistungen</b>
              <br />
              Das Widerrufsrecht erlischt bei einem Vertrag zur Erbringung von
              digitalen Leistungen oder sonstigen Dienstleistungen, wenn wir mit
              der Ausführung des Vertrags bzw. der Dienstleistung begonnen
              haben, Dir also etwa ein digitales Produkt zur Verfügung gestellt
              haben, nachdem Du uns dazu Deine ausdrückliche Zustimmung dazu
              gegeben hast, dass wir mit der Ausführung des Vertrags vor Ablauf
              der Widerrufsfrist beginnen können und Du gleichzeitig Deine
              Kenntnis davon bestätigt hast, dass Du in diesem Fall Dein
              Widerrufsrecht verlierst.
              <br />
              <br />
              – Ende der gesetzlichen Widerrufsbelehrung –
              <br />
              <br />
              <b>Muster-Widerrufsformular</b>
              (Wenn Sie den Vertrag/eine Leistung/eine Buchung widerrufen
              wollen, können Sie uns dieses Formular ausgefüllt zurücksenden.
              Sie sind zur Einhaltung dieser Form jedoch nicht verpflichtet)
              <br />
              An: <br />
              Club of Code Technology GmbH & Co. KG <br />
              Heringer Fahrweg 3 <br />
              65597 Hünfelden <br />
              E-Mail: contact@clubofocode.io <br />
              <br />
              Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*)
              abgeschlossenen Vertrag über die Erbringung der folgenden Leistung
              (*)
              <br />
              <br />
              Bestellt am (*)/erhalten am (*) <br />
              <br />
              Name des/der Verbraucher(s) <br />
              <br />
              Anschrift des/der Verbraucher(s) <br />
              <br />
              Unterschrift des/der Verbraucher(s) <br />
              <br />
              (nur bei Mitteilung auf Papier) <br />
              <br />
              Datum <br />
              <br />
              (*) Unzutreffendes streichen.
            </li>
          </DocumentList>
        </DocumentSegment>
        <br />
        <br />
        <b>Stand: August 2023</b>
      </section>
    </LegalLayout>
  );
};

export default TermsAndConditions;
